<template>
  <div class="FileManagementInput" :class="{ hasFiles: modelValue.length > 0, disabled: disabled }">
    <q-field class="theField" ref="fileInput" :model-value="modelValue" :error="error" :error-message="errorMessage" :rules="rules" hide-hint>
      <div style="width:100%" v-show="modelValue.length > 0">
        <q-list separator bordered class="q-mb-xs FileManagementInputList" dense>
          <q-item v-for="file, index in modelValue" :key="index">
            <q-item-section>
              <q-item-label>{{file.name}}</q-item-label>
              <q-item-label caption><small>{{humanFileSize(file.size)}}</small></q-item-label>
            </q-item-section>
            <q-item-section side>
              <q-btn @click="removeFile(index)" :title="'Datei entfernen: ' + file.name"><Icon :path="mdiDelete"></Icon></q-btn>
            </q-item-section>
          </q-item>
          <q-item>
            <q-item-label caption>
              {{humanFileSize(sumFileSizes)}} insgesamt durch {{modelValue.length}} Datei(en)
            </q-item-label>
          </q-item>
        </q-list>
      </div>
    </q-field>
    <div :class="{ 'q-mt-3' : hasError, 'q-mt-1' : !hasError }">
      <FileUpload
        :disabled="disabled"
        :allowedMimeTypes="allowedMimeTypes"
        :fileTypesText="fileTypesText"
        @complete="addFiles">
      </FileUpload>
    </div>
  </div>
</template>

<script>
import FileUpload from './FileUpload.vue';
import { humanFileSize } from './../humanFileSize';
import Icon from './Icon.vue';
import { mdiDelete } from '@quasar/extras/mdi-v7';
export default {
  components: { FileUpload, Icon },
  props: {
    modelValue: { required:false, type: Array, default: () => ([]) },
    allowedMimeTypes: { required:false, type: Array, default: () => ([
        'image/jpeg',
        'image/png',
        //'application/pdf',
        //'application/msword', // doc
        //'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // docx
        //'application/x-zip-compressed',
        //'application/zip'
      ])
    },
    fileTypesText: { required:false, type: String, default: 'JPG und PNG' },
    errorMessage: { required:false, type: String, default: '' },
    error: { required:false, type:Boolean, default: false },
    rules: { required:false, type:Array, default(){return []} },
    maxFileSizeSum: { required:false, type: [Number, Object], default: null },
    maxFileCount: { required:false, type: [Number, Object], default: null },
    disabled: { required:false, type: Boolean, default: false },
  },
  emits: ['update:modelValue'],
  data: () => ({
    mdiDelete,
  }),
  computed:{
    hasError() {
      return this.$refs.fileInput && this.$refs.fileInput.hasError;
    },
    sumFileSizes() {
      return this.modelValue.reduce((previousValue, elem) => previousValue + elem.size, 0);
    },
    errorMsg() {
      if(!Array.isArray(this.errorMessages)) return null;
      return this.errorMessages;
    }
  },
  methods:{
    humanFileSize,
    addFiles(uploadFiles) {
      let newFilesArray = [];
      if(Array.isArray(this.modelValue)) newFilesArray = newFilesArray.concat(this.modelValue);
      if(Array.isArray(uploadFiles)) {
        newFilesArray = newFilesArray.concat(uploadFiles);
      }
      console.log('addFiles', newFilesArray);
      this.$emit('update:modelValue', newFilesArray);
    },
    removeFile(index) {
      this.$emit('update:modelValue', this.modelValue.filter((elem,i) => i!==index));
    }
  }
}
</script>

<style lang="scss">
.FileManagementInput {
  .theField .q-field__control,
  .theField .q-field__control-container {
    min-height: 0;
    height: auto !important;
  }
  .theField .q-field__append {
    display: none;
  }
  .FileManagementInputList.theme--light.q-list {
    border:1px solid #eee; background: #fafafa;
  }
  &.hasFiles {
    .textIntro { display: none; }
    .dropZoneInfo { min-height: 5rem;}
  }
}
</style>